import React from 'react'
import OvertimeGame from '../Game/OvertimeGame'

type OvertimeUniqueEventsProps = {
  leagues: any
}

const OvertimeUniqueEvents: React.FC<OvertimeUniqueEventsProps> = ({
  leagues,
}) => {
  console.log({ leagues })
  return (
    <div className="space-y-px">
      {leagues.map(({ countrySlug, slug, games }: any) => {
        const leagueUrl = `/v2/unique/${countrySlug}/${slug}`

        return games.map((game: any) => (
          <OvertimeGame
            key={`${leagueUrl}/${game.gameId}`}
            leagueUrl={leagueUrl}
            game={game}
            isUnique
          />
        ))
      })}
    </div>
  )
}

export default OvertimeUniqueEvents
